// extracted by mini-css-extract-plugin
export default {"x":"XButton-module__x__P_o21"};